import { useEffect, useMemo, useState, type CSSProperties } from "react";

export function useViewportUnderHeader(): {
  viewportUnderHeaderPx: string;
  outerStyle: CSSProperties;
} {
  const [viewportUnderHeaderPx, setViewportUnderHeaderPx] =
    useState<string>("100vh");

  useEffect(() => {
    const compute = () => {
      const header = document.querySelector("header");
      const headerH = header?.offsetHeight ?? 0;
      const vvH = window.visualViewport?.height;
      const vp = typeof vvH === "number" && vvH > 0 ? vvH : window.innerHeight;
      const h = Math.max(0, vp - headerH);
      setViewportUnderHeaderPx(`${Math.round(h)}px`);
    };

    compute();
    window.addEventListener("resize", compute);
    window.visualViewport?.addEventListener("resize", compute);

    return () => {
      window.removeEventListener("resize", compute);
      window.visualViewport?.removeEventListener("resize", compute);
    };
  }, []);

  const outerStyle = useMemo(
    () => ({ height: viewportUnderHeaderPx }),
    [viewportUnderHeaderPx],
  );

  return { viewportUnderHeaderPx, outerStyle };
}
